module.exports = __webpack_public_path__ + "img/tryg-logo-small.2ef60b3.png";